import React, { useState } from "react";
import Index from "../../../Index";
import MuiPhoneNumber from "material-ui-phone-number";
import PagesIndex from "../../../PagesIndex";
import {
  buywithcryptoAction,
  updateSubscriptionPackageAction,
} from "../../../../redux/admin/action";

import { ariaLabel } from "../addUser/UserModal.Style";

const EditSubscriptionPackage = ({
  getPackageList,
  handelClose,
  updatePackage,
}) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  // initital values declaration
  let initialValues = {
    id: updatePackage?._id || null,
    appleProviderId: updatePackage?.appleProviderId || "",
    googleProviderId: updatePackage?.googleProviderId || "",
    sapToken: updatePackage?.SAPToken || "",
    maticToken: updatePackage?.maticToken || "",
  };

  // const declaration
  const { adminToken } = PagesIndex.useSelector((state) => state.AdminReducer);

  const handleFormSubmit = (values, { setSubmitting }) => {
    setIsButtonDisabled(true);
    updateSubscriptionPackageAction(values, adminToken).then((res) => {
      if (res?.status === 201 || 200) {
        setIsButtonDisabled(false);
        setSubmitting(false);
        getPackageList();
        handelClose();
      } else {
        setTimeout(() => {
          setIsButtonDisabled(false);
          setSubmitting(false);
        }, 1000);
      }
    });
    setSubmitting(false);
  };

  return (
    <Index.Box className="episap-modal-box">
      <Index.Box className="episap-modal-header">
        <Index.Box className="edit-modal-circle-main">
          <Index.Box className="title-header">
            <Index.Box className="title-header-flex res-title-header-flex category-modal-header">
              <Index.Box className="title-main">
                <Index.Typography
                  variant="p"
                  component="p"
                  className="page-title"
                >
                  Edit Subscription Package
                </Index.Typography>
                {/* <Index.Typography variant="p" component='p' className='page-sub-title'>
                            Please fill the input blow here
                        </Index.Typography> */}
              </Index.Box>
            </Index.Box>
          </Index.Box>
          <Index.Box className="user-circle-img" onClick={handelClose}>
            <img
              src={PagesIndex.Svg.whiteclose}
              className="user-circle-img"
              alt="icon"
            />
          </Index.Box>
        </Index.Box>
      </Index.Box>
      <Index.Box className="admin-design-div login-input-design-div">
        <PagesIndex.Formik
          enableReinitialize
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={PagesIndex.updateSubscriptionPackageSchema}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
          }) => (
            <Index.Stack
              component="form"
              spacing={2}
              noValidate
              autoComplete="off"
              onSubmit={handleSubmit}
            >
              <Index.Box className="register-all-inputs">
                <Index.Box
                  autoComplete="off"
                  className="reg-input warden-modal-box"
                >
                  <Index.Typography className="re-input-label" variant="label">
                    Google Product Id
                  </Index.Typography>
                  <Index.TextField
                    inputProps={ariaLabel}
                    value={values?.googleProviderId}
                    name="Google Provider Id"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      if (e.target.value.length <= 64) {
                        const newValue = e.target.value
                          .replace(/^\s+/, "")
                          .replace(/\s\s+/g, " ");
                        // const capitalizedValue =
                        //   newValue?.charAt(0)?.toUpperCase() +
                        //   newValue.slice(1);
                        setFieldValue("googleProviderId", newValue);
                      }
                    }}
                    helperText={
                      touched.googleProviderId && errors.googleProviderId
                    }
                    error={Boolean(
                      errors.googleProviderId && touched.googleProviderId
                    )}
                  />
                </Index.Box>
                <Index.Box
                  autoComplete="off"
                  className="reg-input warden-modal-box"
                >
                  <Index.Typography className="re-input-label" variant="label">
                    Apple Product Id
                  </Index.Typography>
                  <Index.TextField
                    inputProps={ariaLabel}
                    value={values?.appleProviderId}
                    name="Apple Provider Id"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      if (e.target.value.length <= 64) {
                        const newValue = e.target.value
                          .replace(/^\s+/, "")
                          .replace(/\s\s+/g, " ");
                        // const capitalizedValue =
                        //   newValue?.charAt(0)?.toUpperCase() +
                        //   newValue.slice(1);
                        setFieldValue("appleProviderId", newValue);
                      }
                    }}
                    helperText={
                      touched.appleProviderId && errors.appleProviderId
                    }
                    error={Boolean(
                      errors.appleProviderId && touched.appleProviderId
                    )}
                  />
                </Index.Box>

                <Index.Box
                  autoComplete="off"
                  className="reg-input warden-modal-box"
                >
                  <Index.Typography className="re-input-label" variant="label">
                    SAP Token
                  </Index.Typography>
                  <Index.TextField
                    inputProps={ariaLabel}
                    value={values?.sapToken}
                    name="SAP Token"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setFieldValue("sapToken", newValue);
                    }}
                    helperText={touched.sapToken && errors.sapToken}
                    error={Boolean(errors.sapToken && touched.sapToken)}
                  />
                </Index.Box>

                <Index.Box
                  autoComplete="off"
                  className="reg-input warden-modal-box"
                >
                  <Index.Typography className="re-input-label" variant="label">
                    Matic Token
                  </Index.Typography>
                  <Index.TextField
                    inputProps={ariaLabel}
                    value={values?.maticToken}
                    name="Matic Token"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setFieldValue("maticToken", newValue);
                    }}
                    helperText={touched.maticToken && errors.maticToken}
                    error={Boolean(errors.maticToken && touched.maticToken)}
                  />
                </Index.Box>
              </Index.Box>

              <Index.Box className="modal-footer-btn pt-0">
                <Index.Button
                  variant="contained"
                  className="submit-btn"
                  type="submit"
                  disabled={isButtonDisabled || isSubmitting}
                >
                  UPDATE
                  {/* {isSubmitting ? 'Submitting...' : 'Submit'} */}
                </Index.Button>
              </Index.Box>
            </Index.Stack>
          )}
        </PagesIndex.Formik>
      </Index.Box>
    </Index.Box>
  );
};

export default EditSubscriptionPackage;
